import React, { useMemo } from "react";
import {
  AppPage,
  MimaButton,
  MimaTable,
  PageLoader,
  Searchbar,
} from "../../components";
import { useState } from "react";
import moment from "moment";
import { amountFormatter } from "../../utils/utils";
import { downloadXlsx2 } from "../../utils/download";
import constant from "../../utils/constant";

const ChargeAnalysis = ({
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  setFilterQuery,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.charges || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "expiryDate",
      Cell: ({ cell }) => {
        const createdDate = cell.row.original?.createdAt;
        return <span>{moment(createdDate).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Charge Name",
      accessor: "name",
      Cell: ({ cell }) => {
        const chargeName = cell.row.original.charge?.name;
        return <span>{chargeName}</span>;
      },
    },
    {
      Header: "Total Cost",
      accessor: "totalCost",
      Cell: ({ cell }) => {
        const amount = cell.value;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Charge",
      accessor: "value",
      Cell: ({ cell }) => {
        const chargeAmount = cell.value;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount =
          amountFormatter(currencyCode).format(chargeAmount);
        return <span>{formattedAmount}</span>;
      },
    },
  ];

  // JSON to convert to Excel
  const printData = tableData.map((item) => ({
    Date: item?.createdAt
      ? moment(item?.createdAt).format("DD-MM-YYYY HH:mm a")
      : "",
    "Business Name": item?.business?.tradingName || "",
    "Charge Name": item?.charge?.name || "",
    Currency: item?.currencyCode || "",
    "Total Cost": item?.totalCost?.toFixed(2) || 0,
    Charge: item?.value?.toFixed(2) || 0,
  }));

  return (
    <AppPage pageTitle="Charge Analysis">
      <MimaButton
        title="Download Charge Analysis Report"
        width={30}
        onClick={() => {
          downloadXlsx2(printData);
        }}
        variant="filter"
        mt={2}
      />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Subscription"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
    </AppPage>
  );
};

export default ChargeAnalysis;
